module.exports = "<template> <canvas ref=canvas></canvas> </template> ";